import React, { FunctionComponent } from 'react';

import { ServiceLocation } from 'src/api/@generated/backend-api';

import { ChooseButton } from 'src/components/choose-button';
import { ChooseContainer } from 'src/components/choose-container';
import { Image } from 'src/components/image';
import { ServiceTypeMapper } from 'src/mapper/service-type-mapper';
import { houseImageProps } from 'src/resources/images';
import { selectServiceLocationActionCreator } from 'src/state/address/action-creators/select-address-action-creator';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch } from 'src/state/thunk-api';
import { i18n } from 'src/i18n';

import {
  StyledContentContainer,
  StyledDwellingUnitNumber,
  StyledImageContainer,
  StyledTextContainer,
  StyledTitle,
} from './choose-service-location-content.styled';

interface Props {
  serviceLocations: ServiceLocation[];
}

export const ChooseServiceLocationPageContent: FunctionComponent<Props> = (props) => {
  const { serviceLocations } = props;
  const dispatch = useAppDispatch();

  const renderTitle = (serviceLocation: ServiceLocation) => {
    const { address } = serviceLocation;

    const { streetAddress, dwellingUnitNumber } = address;

    return (
      <StyledContentContainer>
        <StyledImageContainer>
          <Image {...houseImageProps} />
        </StyledImageContainer>
        <StyledTextContainer>
          <StyledTitle variant="paragraph2" component="p" data-hj-suppress={true}>
            {streetAddress}
          </StyledTitle>
          {dwellingUnitNumber && (
            <StyledDwellingUnitNumber variant="paragraph3" component="p" data-hj-suppress={true}>
              {dwellingUnitNumber}
            </StyledDwellingUnitNumber>
          )}
        </StyledTextContainer>
      </StyledContentContainer>
    );
  };

  const renderServiceLocationButton = (serviceLocation: ServiceLocation) => {
    const { services, siteId } = serviceLocation;

    return (
      <ChooseButton
        key={siteId}
        title={renderTitle(serviceLocation)}
        items={services.map(ServiceTypeMapper.toSelectButtonItem)}
        onClick={() => {
          dispatch(selectServiceLocationActionCreator(serviceLocation));
          dispatch(goToStepActionCreator(OrderStep.PRODUCT_SELECT));
        }}
      />
    );
  };

  return (
    <ChooseContainer
      title={i18n.page.chooseServiceLocation.title}
      subTitle={i18n.page.chooseServiceLocation.description}
    >
      {serviceLocations.map(renderServiceLocationButton)}
    </ChooseContainer>
  );
};
